import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, ImageSizeTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, StepperTypeTokens, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { horizontalStepperRepo } from '../../../configs/utils';
import { digilockerAction, GoBackAction, triggerAction } from './actions';
export const template = stepper => {
    return {
        layout: {
            id: ROUTE.KYC_DOCUMENTS_UPLOAD_BASE,
            type: LAYOUTS.LIST,
            widgets: [
                {
                    id: 'header',
                    type: WIDGET.HEADER,
                    position: POSITION.ABSOLUTE_TOP,
                },
                { id: 'topSpace', type: WIDGET.SPACE },
                { id: 'title', type: WIDGET.TEXT },
                { id: 'spaceSubTitle', type: WIDGET.SPACE },
                { id: 'subTitle', type: WIDGET.STACK },
                { id: 'spaceSecondarySubTitle', type: WIDGET.SPACE },
                {
                    id: 'informationCard',
                    type: WIDGET.STACK,
                },
                { id: "spaceXXXXXL", type: WIDGET.SPACE },
                {
                    id: 'stackBottom',
                    type: WIDGET.STACK,
                    position: POSITION.ABSOLUTE_BOTTOM,
                },
            ],
        },
        datastore: {
            header: {
                title: 'KYC Verification',
                type: HeaderTypeTokens.verification,
                stepperProps: {
                    data: stepper,
                    type: StepperTypeTokens.HORIZONTAL,
                },
                action: {
                    type: ACTION.GO_BACK,
                    routeId: ROUTE.KYC_DOCUMENTS_UPLOAD_BASE,
                    payload: {},
                },
            },
            topSpace: { size: SizeTypeTokens.MD },
            title: {
                label: 'KYC via document upload',
                color: ColorTokens.Grey_Night,
                fontSize: FontSizeTokens.MD,
                fontFamily: FontFamilyTokens.Poppins,
                fontWeight: '600',
                lineHeight: 24,
            },
            spaceSubTitle: { size: SizeTypeTokens.SM },
            subTitle: {
                justifyContent: StackJustifyContent.flexStart,
                alignItems: StackAlignItems.flexStart,
                type: StackType.column,
                widgetItems: [
                    { id: 'subtitleLabel', type: WIDGET.TEXT },
                    { id: 'subtitleAction', type: WIDGET.STACK },
                ],
            },
            subtitleLabel: {
                label: 'Don’t have documents available? ',
                fontSize: FontSizeTokens.SM,
                color: ColorTokens.Grey_Charcoal,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                lineHeight: 18,
            },
            subtitleAction: {
                justifyContent: StackJustifyContent.flexStart,
                alignItems: StackAlignItems.flexStart,
                type: StackType.column,
                width: StackWidth.CONTENT,
                widgetItems: [{ id: 'subtitleActionText', type: WIDGET.TEXT }],
                action: {
                    type: ACTION.DIGILOCKER_ACTION,
                    routeId: ROUTE.KYC_DOCUMENTS_UPLOAD_BASE,
                    payload: {},
                },
            },
            subtitleActionText: {
                label: 'Get via DigiLocker',
                fontSize: FontSizeTokens.SM,
                color: ColorTokens.Primary_100,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
                lineHeight: 18,
            },
            subTitleSpace: { size: SizeTypeTokens.XL },
            continue: {
                type: ButtonTypeTokens.LargeFilled,
                label: 'Proceed with document upload',
                width: ButtonWidthTypeToken.FULL,
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.MD,
                lineHeight: SizeTypeTokens.XXL,
                fontWeight: '700',
                action: {
                    type: ACTION.TRIGGER_CTA,
                    routeId: ROUTE.KYC_DOCUMENTS_UPLOAD_BASE,
                    payload: {},
                },
            },
            spaceBelowCTA: { size: SizeTypeTokens.MD },
            stackBottom: {
                justifyContent: StackJustifyContent.center,
                alignItems: StackAlignItems.center,
                type: StackType.column,
                widgetItems: [
                    { id: 'continue', type: WIDGET.BUTTON },
                    { id: 'spaceBelowCTA', type: WIDGET.SPACE },
                ],
            },
            spaceSecondarySubTitle: { size: SizeTypeTokens.XXXXL },
            informationCard: {
                bgColor: ColorTokens.White,
                padding: {
                    all: SizeTypeTokens.XL,
                },
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.flexStart,
                width: StackWidth.FULL,
                borderConfig: {
                    borderWidth: {
                        all: SizeTypeTokens.XS,
                    },
                    borderRadius: BorderRadiusTokens.BR2,
                    borderColor: ColorTokens.Grey_Chalk,
                },
                widgetItems: [
                    { id: 'image1', type: WIDGET.IMAGE },
                    { id: 'spaceCard', type: WIDGET.SPACE },
                    { id: 'text1', type: WIDGET.TEXT },
                    { id: 'spaceCard', type: WIDGET.SPACE },
                    { id: 'checklistItem1', type: WIDGET.STACK },
                    { id: 'spaceCard', type: WIDGET.SPACE },
                    { id: 'checklistItem2', type: WIDGET.STACK },
                ],
            },
            image1: {
                size: ImageSizeTokens.LG,
                uri: 'https://volt-images.s3.ap-south-1.amazonaws.com/upload_manual_doc.svg',
                padding: SizeTypeTokens.NONE,
            },
            text1: {
                label: 'Upload these documents',
                fontSize: FontSizeTokens.SM,
                color: ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '500',
                lineHeight: 18,
            },
            checklistItem1: {
                justifyContent: StackJustifyContent.flexStart,
                alignItems: StackAlignItems.flexStart,
                type: StackType.row,
                width: StackWidth.MATCH_PARENT,
                widgetItems: [
                    { id: 'iconItem1', type: WIDGET.TEXT },
                    { id: 'textItem1', type: WIDGET.TEXT },
                ],
            },
            iconItem1: {
                label: '1. ',
                fontSize: FontSizeTokens.SM,
                color: ColorTokens.Grey_Charcoal,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                lineHeight: 18,
            },
            textItem1: {
                label: 'Aadhaar Card',
                fontSize: FontSizeTokens.SM,
                color: ColorTokens.Grey_Charcoal,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                lineHeight: 18,
            },
            checklistItem2: {
                justifyContent: StackJustifyContent.flexStart,
                alignItems: StackAlignItems.flexStart,
                type: StackType.row,
                widgetItems: [
                    { id: 'iconItem2', type: WIDGET.TEXT },
                    { id: 'textItem2', type: WIDGET.TEXT },
                ],
            },
            iconItem2: {
                label: '2. ',
                fontSize: FontSizeTokens.SM,
                color: ColorTokens.Grey_Charcoal,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                lineHeight: 18,
            },
            textItem2: {
                label: 'PAN',
                fontSize: FontSizeTokens.SM,
                color: ColorTokens.Grey_Charcoal,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                lineHeight: 18,
            },
            spaceCard: { size: SizeTypeTokens.LG },
            spaceXXXXXL: {
                size: SizeTypeTokens.XXXXXL
            }
        },
    };
};
export const kycDocumentsUploadBaseMF = {
    onLoad: async ({ network }) => {
        const stepper = await horizontalStepperRepo(network);
        return Promise.resolve(template(stepper));
    },
    actions: {
        [ACTION.GO_BACK]: GoBackAction,
        [ACTION.TRIGGER_CTA]: triggerAction,
        [ACTION.DIGILOCKER_ACTION]: digilockerAction,
    },
    clearPrevious: true,
};
